import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { DatePipe } from '@angular/common';
import { RoutingState } from './shared/services/RoutingState'
import {  } from 'lodash-es';
import { RollbarErrorHandler, RollbarService, rollbarFactory } from './core/services/rollbar';

declare module '@angular/core' { interface ModuleWithProviders<T = any> { ngModule: Type<T>; providers?: Provider[]; } }

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    BrowserAnimationsModule,
    HttpClientModule
    
  ],
  providers: [
    DatePipe,
    RoutingState,
    { provide: ErrorHandler, useClass: RollbarErrorHandler },
    { provide: RollbarService, useFactory: rollbarFactory }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
